if (typeof gsap !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  const wideViewport = window.matchMedia('(min-width: 992px)');
  const container = document.getElementById('hof-container');
  const sections = gsap.utils.toArray('.hof-panel');
  const listNav = gsap.utils.toArray('.hof-list__nav');
  const listYearsCont = document.querySelector('.hof-list__years');
  const nav = document.getElementById('hof-nav');
  const navLinks = gsap.utils.toArray('#hof-nav li');
  const hofList = document.getElementById('hof-list');
  const inducteeLinks = gsap.utils.toArray('.hof-year a');
  const inducteeCards = document.querySelectorAll('.inductee-card-cont');
  const getMaxWidth = () => sections.reduce((val, section) => val + section.offsetWidth, 0);

  ScrollTrigger.matchMedia({
    // Desktop - build GSAP functionality
    "(min-width: 992px)": function() {

      let maxWidth = getMaxWidth(),
          scrollSpeed = 4,
          activeNavIndex = 0,
          snapProgress,
          closestLabel,
          lastScrollTween = Date.now(),
          tl = gsap.timeline();

      navLinks[0].classList.add('active');

      tl.to(sections, {
        x: () => window.innerWidth - maxWidth,
        duration: 1,
        ease: 'none'
      });

      ScrollTrigger.create({
        animation: tl,
        trigger: container,
        pin: true,
        scrub: 1,
        // snap: {snapTo: directionalSnap(tl), duration: 0.5},
        end: () => '+=' + maxWidth / scrollSpeed,
        invalidateOnRefresh: false
      });

      gsap.set(sections, {x: 0});
      maxWidth = getMaxWidth();

      let position = 0,
          distance = maxWidth - window.innerWidth;

      // Add timeline labels to mark panel positions
      tl.add('label0', 0);
      sections.forEach((section, i) => {
        let progress = position;
        position += section.offsetWidth / distance;
        sections[i].setAttribute('data-pos', position);
        tl.add('label' + (i+1), position);
        navLinks[i].onclick = () => {
          snapProgress = progress;
          lastScrollTween = Date.now();
          pos = maxWidth / scrollSpeed * progress;
          gsap.to(window, {scrollTo: pos, duration: 1, overwrite: 'auto'});
        }
      });

      // If user is coming from a bio page take them back to where the year they came from
      if (window.location.hash) {
        const year = 'hof-' + window.location.hash.substring(1);
        const section = document.getElementById(year);
        const index = Array.from(document.querySelectorAll('.hof-panel')).indexOf(section);
        gsap.to(window, {
          scrollTo: tl.scrollTrigger.labelToScroll('label' + index),
          delay: 0
        });
      }

      closestLabel = closestLabelFunction(tl);

      // Add active class to nearest timeline link
      function setActiveNav(index) {
        // Hide the HOF navigation if not viewing a year
        if (index < 2) {
          nav.style.display = 'none';
        } else {
          nav.style.display = 'block';
        }

        // Set/remove active class based on year being viewed
        navLinks[activeNavIndex].classList.remove('active');
        navLinks[index].classList.add('active');
        activeNavIndex = index;
      }

      // Function to find the closest label to a nav item
      function closestLabelFunction(timeline) {
        let a = [],
            snap, p;

        for (p in timeline.labels) {
          a.push(timeline.labels[p] / timeline.duration());
        }

        snap = gsap.utils.snap(a);
        return value => a.indexOf(snap(value));
      }

      tl.eventCallback('onUpdate', () => {
        if (nav) {
          let i = closestLabel(tl.progress());
          if (i !== activeNavIndex) {
            setActiveNav(i);
          };
        }
      });

      // Setup snapping triggers
      function directionalSnap(timeline) {
        return (value, st) => {
          if (Date.now() - lastScrollTween < 1650) {
            return snapProgress;
          }
          
          let a = [],
              labels = timeline.labels,
              duration = timeline.duration(),
              p, i;

        for (p in labels) {
          a.push(labels[p] / duration);
        }

        a.sort((a, b) => a - b);
        
        if (st.direction > 0) {
          for (i = 0; i < a.length; i++) {
            if (a[i] >= value) {
              return a[i];
            }
          }
          return a.pop();
        } else {
          i = a.length;
          while (i--) {
            if (a[i] <= value) {
              return a[i];
            }
          }
        }
        return a[0];
        };
      }

      ScrollTrigger.addEventListener('refreshInit', function() {
        maxWidth = getMaxWidth();
      });

      // Clear active card when a new card is selected
      function clearActiveCard() {
        inducteeCards.forEach(function(cards, i) {
          if (cards.classList.contains('active')) {
            cards.querySelectorAll('.inductee-card').forEach(function(card) {
              card.classList.toggle('card-flip');
            });
          }
          inducteeCards[i].classList.remove('active');
        });
      }

      // Year list navigation
      const perPage = 12;
      const totalYears = document.querySelectorAll('.hof-year').length;
      const totalPages = Math.ceil(totalYears/perPage);
      let currPage = 1;
      listNav.forEach(element => {
        element.addEventListener('click', function() {
          const yearCont = document.querySelector('.hof-year');
          const yearContHeight = listYearsCont.offsetHeight;
          const currentTop = parseInt(getComputedStyle(listYearsCont).top.replace('px',''));
          let newTop;

          if (this.classList.contains('nav-next')) {
            newTop = currentTop - yearContHeight;
            document.querySelector('.nav-prev').style.display = 'block';
            currPage++;
          } else {
            newTop = currentTop + yearContHeight;
            currPage--;
          }
          listYearsCont.style.top = newTop+'px';

          if (currPage === 1) {
            document.querySelector('.nav-prev').style.display = 'none';
            document.querySelector('.nav-next').style.display = 'block';
          } else if (currPage === totalPages) {
            document.querySelector('.nav-next').style.display = 'none';
            document.querySelector('.nav-prev').style.display = 'block';
          }
        });
      });

      // Flip card over on click
      inducteeCards.forEach(function(cards, i) {
        cards.addEventListener('click', event => {
          console.log('clicked');
          if (!cards.classList.contains('active')) {
            clearActiveCard();
          }
          cards.classList.toggle('active');
          cards.querySelectorAll('.inductee-card').forEach(function(card) {
            e = window.event;
            if(!e.target.href) {
              card.classList.toggle('card-flip');
            }
          });
        });
      });

      // Scroll to year when an inductee is selected in the left nav
      inducteeLinks.forEach(element => {
        element.addEventListener('click', function(e) {
          e.preventDefault();

          // Get index of selected year and add 2 to account for intro sections
          const index = parseInt(this.getAttribute('data-index')) + 2;

          // Get the ID of the selected inductee
          const inducteeID = this.getAttribute('data-id');
          const selectedInductee = document.querySelector('.inductee-card-cont[data-id="'+inducteeID+'"]');

          // Close the nav menu and clear previously active card if there is one
          hofList.classList.toggle('open');
          clearActiveCard();

          // Go to selected inductee
          gsap.to(window, {
            scrollTo: tl.scrollTrigger.labelToScroll('label' + index),
            duration: 2
          });
        });
      });

      // Open inductee list
      document.querySelector('.hof-list__tab').addEventListener('click', function (event) {
        this.parentNode.classList.toggle('open');
      });

      // Close inductee list if user clicks outside of it
      document.addEventListener('mouseup', function(e) {
        if (!hofList.contains(e.target)) {
          if (hofList.classList.contains('open')) {
            hofList.classList.remove('open');
          }
        }
      });
    },

    // Mobile - Kill GSAP functionality
    "(max-width: 991px)": function() {
      ScrollTrigger.getAll().forEach(st => st.kill());

      // If user is coming from a bio page take them back to where the year they came from
      if (window.location.hash) {
        const year = window.location.hash.split('#')[1];
        const yearEle = document.getElementById('hof-' + year);

        window.scroll({
          behavior: 'smooth',
          left: 0,
          top: yearEle.offsetTop - 30
        });
      }
    }
  });
}